import { autoinject } from 'aurelia-dependency-injection';
import { HttpClient, json } from 'aurelia-fetch-client';
import { FeatureInfo } from './organization-info';
import { LicenseStatusCode } from '../components/license-status';

@autoinject
export class LicenseInfo {

    constructor(private http: HttpClient) {
        http.configure(x => {
            x.useStandardConfiguration()
        });
    }

    async validateLicenseForFeature(feature: FeatureInfo, license: any, prefix: string, organizationid: string) {
        
        const isConsumptionBased = license[`${prefix}_isconsumptionbased`];
        const isTrial = license[`${prefix}_istrial`];

        // Build request for validate license
        const request = {
            "OrganizationId": organizationid,
            "FeatureCode": feature.featureCode,
            "Signature": license[`${prefix}_signature`],
            "IsConsumptionBased": isConsumptionBased
        };

        if (isConsumptionBased) {
            request["ApiKey"] = license[`${prefix}_apikey`];
        }
        else {
            request["ExpirationDate"] = license[`${prefix}_expirationdate`];
            request["FinalExpirationDate"] = license[`${prefix}_finalexpirationdate`];
            request["UsageQuery"] = license[`${prefix}_usagequery`];
        }

        return this.http
            .fetch("/api/validatelicense", {
                method: 'post',
                body: json(request)
            })
            .then(response => response.json())
            .then(licenseStatus => {
                // Set status
                feature.licenseStatus = licenseStatus;
                
                // Set status to 'Trial License' when not expired
                if (isTrial && licenseStatus !== "Expired") {
                    feature.licenseStatus = LicenseStatusCode.TrialLicense;
                }

                return licenseStatus;
            });
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/services/license-info.ts